import { mapState } from 'vuex';
import MarkdownItVueLight from 'markdown-it-vue/dist/markdown-it-vue-light.umd.min.js';
export default {
  name: 'ViewApi',
  components: {
    MarkdownItVueLight
  },
  data: function () {
    return {
      buttons01: [{
        title: this.$i18n_t('Common.open'),
        icon: 'fal fa-external-link',
        action: 'open',
        valid: true
      }]
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color']),
    originUrl() {
      return location.origin;
    },
    xapiProtocol() {
      return location.protocol.replace(':', '');
    },
    xapiHost() {
      // XAPI stays on separate domain - set VUE_APP_XAPI_HOST
      return process.env.VUE_APP_XAPI_HOST;
    },
    fireflyHost() {
      return process.env.VUE_APP_FIREFLY_HOST;
    },
    n20aText() {
      return this.$i18n_t('Common.api.n20a', {
        url: `${this.xapiProtocol}://${this.xapiHost}/swagger/v1/`
      });
    }
  },
  methods: {
    open(a) {
      let link;
      if (a === 'n20a') {
        link = `${this.xapiProtocol}://${this.xapiHost}/swagger/v1/`;
      }
      if (a === 'n10a') {
        link = 'https://apidocs.niota.io';
      }
      if (a === 'firefly') {
        link = `https://apidocs.${this.fireflyHost}`;
      }
      window.open(link, '_blank');
    }
  }
};